import { render, staticRenderFns } from "./GoogleTag.vue?vue&type=template&id=4c37a610&scoped=true&"
import script from "./GoogleTag.vue?vue&type=script&lang=js&"
export * from "./GoogleTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37a610",
  null
  
)

export default component.exports